import React from 'react';

const PoliticaPrivacidade = () => {
  return (
    <div className="mt-16 max-w-4xl mx-auto px-6 py-12">
      <h1 className="text-4xl font-bold mb-6 text-center">
        Política de Privacidade
      </h1>

      <p className="mb-4">
        Bem-vindo à <strong>Atende24h</strong>, plataforma de multiatendimento e automação com Inteligência Artificial.
        Esta Política de Privacidade descreve como coletamos, usamos e protegemos as suas informações.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">1. Coleta de Dados</h2>
      <p className="mb-4">
        Podemos coletar dados pessoais como nome, e-mail, telefone, e informações relacionadas ao atendimento,
        além de registros de conversas com nossos assistentes virtuais e humanos.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">2. Uso das Informações</h2>
      <p className="mb-4">
        Utilizamos os dados para:
      </p>
      <ul className="list-disc pl-8 mb-4">
        <li>Personalizar o atendimento e agilizar as respostas;</li>
        <li>Aprimorar nossos serviços e automações;</li>
        <li>Contato direto em casos específicos;</li>
        <li>Análises internas e segurança.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">3. Compartilhamento de Dados</h2>
      <p className="mb-4">
        Seus dados não são vendidos. Podemos compartilhar com parceiros de tecnologia para fins de operação da plataforma,
        sempre sob contrato e com proteção adequada.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">4. Segurança</h2>
      <p className="mb-4">
        Adotamos as melhores práticas de segurança para proteger suas informações, incluindo criptografia e controle de acesso.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">5. Seus Direitos</h2>
      <p className="mb-4">
        Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento, conforme a Lei Geral de Proteção de Dados (LGPD).
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">6. Alterações nesta Política</h2>
      <p className="mb-4">
        Podemos atualizar esta política para refletir mudanças legais ou operacionais. Sempre que possível, avisaremos previamente.
      </p>

      <p className="mt-8 text-sm text-gray-600">
        Última atualização: 11 de julho de 2025
      </p>
    </div>
  );
};

export default PoliticaPrivacidade;
